import axios from "axios";

const api = axios.create({
  baseURL: 'https://sijap.japmetais.com.br/sijap',
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 403) {
      const token = localStorage.getItem('token');
      if (token) {
        localStorage.removeItem('token');
        localStorage.removeItem('id');
      }
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;